export const GET_AGENCIES = 'GET_AGENCIES'
export const GET_AGENCIES_ERR = 'GET_AGENCIES_ERR'